
import { Modal } from "reactstrap";
import { useState, useEffect, useRef } from 'react'
import ApiService from "../../services/apiService";



const SldPopUp = ({
  
    isOpen,
    onClose,
    breakerName,
    container,
  }: {
    isOpen: boolean;
    onClose: () => void;
    breakerName : string;
    style?: React.CSSProperties;
            container?: HTMLElement | null;
  }) =>{

const targetRef = useRef<HTMLDivElement>(null); 
    const[loading,setloading] = useState<Boolean>(true)
    


    const [PumpData, setpumpdata] = useState<any[]>([]);
      const getAllPumpingStations = async () => {
        try {
          const response = await ApiService.axiosApi(`/tags`, {
            method: "GET",
          });
    
          if (response.success) {
            console.log(response.data);
            setpumpdata(response.data);
            setloading(false)
            console.log("Fetched all pumping stations successfully");
          } else {
            console.error("Failed to fetch pumping stations");
          }
        } catch (error) {
          console.error("Error fetching pumping stations:", error);
          console.log("Error fetching pumping stations");
        }
      };


      useEffect(() => {
        getAllPumpingStations();
      
        // Move setInterval inside useEffect
        const interval = setInterval(() => {
          getAllPumpingStations();
        }, 1000); 
      
        // Cleanup interval on unmount
        return () => clearInterval(interval);
      }, []); // keep dependency array
      

     const breakerDisplayNames: { [key: string]: string } = {
   PMP1 : 'VCB-1',
   PMP2 : 'VCB-2',
   PMP3 : 'VCB-3',
   PMP4 : 'VCB-4',
   PMP5 : 'VCB-5',
  LT1: 'LT INCOMER-01',
  LT2: 'LT INCOMER-02',
 AUX_TRX1 : '33/0.433 KV AUX TX',
  KV6_6_INC1 :'33/6.6KV PTX-01',
 KV6_6_INC2 : '33/6.6KV PTX-02',
 KV33_INC1 : '33KV MAIN INCOMER'
  };
    
     
    return(
         <>
<Modal isOpen={isOpen} size='md' centered toggle={onClose}
      style={{
        zIndex: 9999, // High z-index
      }}
       container={container || document.body} // Use container prop or fallback to body
        
      modalClassName="custom-modal-class"
        backdropClassName="custom-backdrop-class"
        contentClassName="custom-content-class"  >

 <div className="mfm-panel">
    
    <div className="mfm-header">
      <span>{ breakerDisplayNames[breakerName] || breakerName}</span>
      <div className="mfm-icons">
        <span className="refresh"onClick={getAllPumpingStations} style={{ cursor: 'pointer' }}>⟳</span>
        <span className="close" onClick={onClose}>✕</span>
      </div>
    </div>

   
    <table className="mfm-table">
      <tr>
  <td>VOLTAGE LINE A-B</td>
  <td className="value">
    {PumpData.find(tag => tag.name === `${breakerName}_Vab`)?.value ?? '0'}
  </td>
  <td>V</td>
</tr>

    <tr>
  <td>VOLTAGE LINE B-C</td>
  <td className="value">{PumpData.find(tag => tag.name === `${breakerName}_Vbc`)?.value ?? '0'}</td>
  <td>V</td>
</tr>
<tr>
  <td>VOLTAGE LINE C-A</td>
  <td className="value">{PumpData.find(tag => tag.name === `${breakerName}_Vca`)?.value ?? '0'}</td>
  <td>V</td>
</tr>
<tr>
  <td>LINE CURRENT-A</td>
  <td className="value">{PumpData.find(tag => tag.name === `${breakerName}_Ia`)?.value ?? '0'}</td>
  <td>A</td>
</tr>
<tr>
  <td>LINE CURRENT-B</td>
  <td className="value">{PumpData.find(tag => tag.name === `${breakerName}_Ib`)?.value ?? '0'}</td>
  <td>A</td>
</tr>
<tr>
  <td>LINE CURRENT-C</td>
  <td className="value">{PumpData.find(tag => tag.name === `${breakerName}_Ic`)?.value ?? '0'}</td>
  <td>A</td>
</tr>
<tr>
  <td>TOTAL KWH</td>
  <td className="value">{PumpData.find(tag => tag.name === `${breakerName}_KWH`)?.value ?? '0'}</td>
  <td>KWH</td>
</tr>
<tr>
  <td>POWER FACTOR</td>
  <td className="value">{PumpData.find(tag => tag.name === `${breakerName}_PF`)?.value ?? '0'}</td>
  <td>PF</td>
</tr>
<tr>
  <td>ACTIVE POWER</td>
  <td className="value">{PumpData.find(tag => tag.name === `${breakerName}_KW`)?.value ?? '0'}</td>
  <td>KW</td>
</tr>
<tr>
  <td>KWH/DAY</td>
  <td className="value">{PumpData.find(tag => tag.name === `${breakerName}_KWH_DAY`)?.value ?? '0'}</td>
  <td>KWH/DAY</td>
</tr>


    </table>
  </div>

  </Modal>
         </>
    )
}

export default SldPopUp